import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import Whiteboard from 'components/Whiteboard';

export const WhiteboardModalComponent = ({ canvasSVGObject }) => {
    return <ExtendedContentContainer extendedContentType={ExtendedContentType.Whiteboard}>
        <Whiteboard canvasSVGObject={canvasSVGObject} />
    </ExtendedContentContainer>
};
